import React, { forwardRef, useRef } from "react";
import InfoRounded from '@mui/icons-material/InfoRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import "./styles.css";

const BaseInput = forwardRef(({ value, onInput, label, placeholder, className, variant = 'light', size, fullWidth, autoScroll, onFocus, huge, ...props }, ref) => {
    const hasValue = value && value.toString().trim().length > 0;
    const currentLength = value ? value.toString().length : 0;
    const showCounter = size && (size - currentLength < (size * 0.2) + 20);
    const textareaRef = useRef(null);
    const inputRef = useRef(null);
    const containerRef = useRef(null);

    const handleFocus = (e) => {
        if (autoScroll && containerRef.current) {
            setTimeout(() => {
                containerRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 100);
        }
        if (onFocus) {
            onFocus(e);
        }
    };

    const handleClear = (e) => {
        e.stopPropagation();
        if (onInput) {
            onInput('');
        }
    };

    const setInputRef = (element) => {
        inputRef.current = element;
        if (ref) {
            if (typeof ref === 'function') {
                ref(element);
            } else {
                ref.current = element;
            }
        }
    };

    const setTextareaRef = (element) => {
        textareaRef.current = element;
        if (ref) {
            if (typeof ref === 'function') {
                ref(element);
            } else {
                ref.current = element;
            }
        }
    };

    return (
        <div ref={containerRef} className={
            `CustomInput_container 
            ${props.disabled ? 'disabled' : ''}
            ${props.error ? 'error' : ''}
            ${className || ''}
            ${variant === 'large' ? 'large' : 'small'}
            ${fullWidth ? 'full-width' : ''}
            `} style={{ position: "relative" }}>

            {
                label && (
                    <span className="CustomInput_label">
                        {label}
                    </span>
                )
            }

            <div className={`CustomInput_platform-input-base ${huge ? 'huge' : ''} ${props.multiline ? 'multiline' : ''}`}>
                <div className="input-main-row">
                    {
                        props.start && (
                            <span className={`input-start-icon input-icon ${typeof (props.start) === 'string' ? 'start-text' : ''}`}>
                                {props.start}
                            </span>
                        )
                    }

                    {
                        props.multiline ? (
                            <textarea
                                ref={setTextareaRef}
                                placeholder={placeholder}
                                value={value || ''}
                                onChange={(e) => onInput(e.target.value)}
                                onFocus={handleFocus}
                                className={`custom-input custom-input-${variant}`.trim()}
                                {...props}
                            />
                        ) : (
                            <input
                                ref={setInputRef}
                                placeholder={placeholder}
                                value={value || ''}
                                onChange={(e) => onInput(e.target.value)}
                                onFocus={handleFocus}
                                className={`custom-input custom-input-${variant}`.trim()}
                                {...props}
                            />
                        )
                    }

                    {hasValue && (
                        <span className="input-clear" onClick={handleClear}>
                            <CloseRoundedIcon />
                        </span>
                    )}

                    {
                        props.end && (
                            <span className="input-end-icon input-icon">
                                {props.end}
                            </span>
                        )
                    }
                </div>
            </div>

            {
                props.helper || showCounter ? (
                    <div className="CustomInput_bottom">
                        {
                            <span className="CustomInput_helper">
                                {props.helper && <InfoRounded />}
                                <span>
                                    {props.helper || null}
                                </span>
                            </span>
                        }
                        {showCounter && (
                            <div className="CustomInput_counterBox">
                                {currentLength}/{size}
                            </div>
                        )}
                    </div>
                ) : null
            }
        </div>
    );
});

export default BaseInput;
